export default __webpack_public_path__ + "static/media/ac_dd.3da12002.bmp";